import { languageEndpointSelector } from "@/store/language-select/selectors/languageEndpointSelector";
import { RootState } from "@/store/store";
import { AvailableLanguages } from "@/components/common/language-select/utils/types/types";

export const languageSelector = (state: RootState) => {
  return (languageEndpointSelector(state)?.data?.value ??
    "en") as AvailableLanguages;
};
